import React, { Component } from 'react'
import PropTypes from "prop-types"
import { connect } from "react-redux"

import VisualizationDisplay from 'search-new/components/Visualization/VisualizationDisplay/index'

import * as sharedSelectors from 'shared/search/selectors'
import * as webSelectors from 'search-new/selectors'

import { updateFilter, updateMultipleFilters } from 'shared/search/action-creators'
import {
    registerVisualization,
    setSecondaryGraphKeys,
    loadVisualizationData,
    updateVisualizationSelection,
    clearVisualizationSelection,
} from 'search-new/action-creators'

const mapStateToProps = (state, props) => ({
    currentFilters: sharedSelectors.selectCurrentFiltersWithId(state, props),
    currentCount: sharedSelectors.selectCurrentCount(state, props),
    countIsLoading: sharedSelectors.selectIsCountLoading(state, props),
    visualizationFilterValues: webSelectors.selectVisualizationFilterValues(state, props),
    data: webSelectors.selectVisualizationData(state, props),
    extraData: webSelectors.selectExtraVisualizationData(state, props),
    isVisualizationRegistered: webSelectors.selectIsVisualizationRegistered(state, props),
    isVisualizationLoading: webSelectors.selectIsVisualizationLoading(state, props),
    isVisualizationDataEmpty: webSelectors.selectIsVisualizationDataEmpty(state, props),
    secondaryGraphKeys: webSelectors.selectSecondaryGraphKeys(state, props),
    serializationFunctions: webSelectors.selectVisualizationSerializeFunctions(state, props),
    selectedValues: webSelectors.selectVisualizationSelectedValues(state, props),
    storedGraphs: webSelectors.selectStoredGraphs(state, props),
    designColorConfigs: webSelectors.selectVisualizationDesignColorConfigs(state, props),
})

const actions = {
    updateFilter,
    updateMultipleFilters,
    registerVisualization,
    setSecondaryGraphKeys,
    loadVisualizationData,
    updateVisualizationSelection,
    clearVisualizationSelection,
}

export default connect(mapStateToProps, actions)(VisualizationDisplay)
